import type { FetchPageServiceParameters } from "~/core/composables/useFetchPageV2";
import { DEFAULT_SORT_CONTENT_RESOURCE } from "~/core/constants/constants";
import type { ContentResource } from "~/core/models/ContentResource.interface";
import type { PaginatedList } from "~/core/models/PaginatedList.interface";
import RestService from "~/core/services/rest.service";
import organizationService from "~/modules/organization/services/organization.service";

export class ContentService extends RestService {
  /**
   * Find a resource
   * @param organizationCode
   * @param page
   * @param pageSize
   * @param filter
   * @param sort
   */
  async findContentResources({
    organizationCode,
    page,
    pageSize,
    searchParams,
    sort,
  }: FetchPageServiceParameters): Promise<PaginatedList<ContentResource>> {
    const params = {
      page,
      pageSize,
      filter: searchParams,
      sort: sort ?? DEFAULT_SORT_CONTENT_RESOURCE,
    };

    return this.$apiV4.get(this.getOrganizationContentsPath(organizationCode), {
      params,
    });
  }

  /**
   * Download a file from content manager
   * @param organizationCode
   * @param contentResourceUid
   * @param fileResourceUid
   */
  async getFile(
    organizationCode: number,
    contentResourceUid: string,
    fileResourceUid: string,
  ): Promise<BlobPart> {
    return this.$apiV4.get(
      `${this.getOrganizationContentsPath(organizationCode)}/${contentResourceUid}/files/${fileResourceUid}`,
      {
        headers: { Accept: "application/octet-stream" },
        responseType: "arraybuffer",
        timeout: Infinity,
      },
    );
  }

  private getOrganizationContentsPath(
    organizationCode: number | undefined,
  ): string {
    return `${organizationService.getOrganizationPath(organizationCode)}/contents`;
  }
}

export default new ContentService();
